import * as React from 'react'
import * as clsx from 'clsx'
import { ModalParams } from '@components/modals/types'

export const ModalMobileImage = ({ imageWrapperClassName, imageClassName, image }: Partial<ModalParams>) => (
  <div className={clsx('p-3 w-100 d-flex align-items-center justify-content-center', imageWrapperClassName)}>
    <img src={image} className={clsx('mw-100', imageClassName)} />
  </div>
)
